import React from "react";
import { Link } from "react-router-dom";
import { useBranding } from "../../../contexts/BrandingContext";
import { useTheme } from "../../../contexts/ThemeContext";
import { useDirection } from "../../../contexts/DirectionContext";

interface BrandLogoProps {
  className?: string;
  imageClassName?: string;
  textClassName?: string;
  showLink?: boolean;
  withMargin?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  className = "flex items-center gap-3",
  imageClassName = "h-10 w-auto",
  textClassName = "text-2xl font-bold text-text-primary font-major",
  showLink = true,
  withMargin = false,
}) => {
  const { branding } = useBranding();
  const { theme } = useTheme();
  const { isRTL } = useDirection();

  const logoSrc =
    theme.mode === "dark"
      ? branding.logo.dark || branding.logo.light
      : branding.logo.light;

  const marginClass = withMargin ? (isRTL ? 'ml-8' : 'mr-8') : '';

  const content = (
    <>
      {logoSrc && (
        <img
          src={logoSrc}
          alt={branding.organizationName}
          className={imageClassName}
        />
      )}
      <span className={textClassName}>{branding.organizationName}</span>
    </>
  );

  if (showLink) {
    return (
      <Link to="/" className={`${className} ${marginClass}`}>
        {content}
      </Link>
    );
  }

  return <div className={`${className} ${marginClass}`}>{content}</div>;
};

export default BrandLogo;
